// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.translate-view .ag-grid-vue {
	flex: 1
}
.translate-view .ag-row.added {
	background: var(--bs-success-bg-subtle);
}
.translate-view .ag-row.changed {
	background: var(--bs-info-bg-subtle);
}
.translate-view .ag-row.changed-remote {
	background: var(--bs-warning-bg-subtle);
}
.translate-view .ag-row.deleted {
	background: var(--bs-danger-bg-subtle);
}
.translate-view .ag-row.deleted .ag-cell {
	text-decoration: line-through;
}
.translate-view .cell-wrap-text {
	white-space: normal !important;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
